// plan-20 S01: the baked tuning preset — source: handoff/reference/preset.json
// The locked in-browser tuning the forge produced. These are the vague-ifier's
// defaults; a visitor's tweaks in the tuning sheet are session-only (no schema
// field). Never hand-tune here without re-baking a preset in the reference.

export type CaptionPos = 'bl' | 'br' | 'tl' | 'tr' | 'cb'

export interface PassSetting {
  on: boolean
  mult: number
}

export interface CaptionSetting {
  on: boolean
  pos: CaptionPos
  size: number
}

export interface Preset {
  passes: Record<string, PassSetting>
  caption: CaptionSetting
  inspector: boolean
}

export const PRESET: Preset = {
  passes: {
    grade: { on: true, mult: 1 },
    grain: { on: true, mult: 1 },
    aberr: { on: true, mult: 1 },
    quantize: { on: true, mult: 1 },
    dither: { on: true, mult: 1 },
    posterize: { on: true, mult: 1 },
    scanlines: { on: true, mult: 1 },
    wave48: { on: true, mult: 1 },
    hsync: { on: true, mult: 1 },
    mosaic: { on: false, mult: 1 },
    melt: { on: true, mult: 1 },
    matrix48: { on: true, mult: 1 },
    bloom: { on: true, mult: 1 },
    mesh: { on: true, mult: 1 },
    vignette: { on: true, mult: 1 },
    glyphs: { on: true, mult: 1 },
    sigil: { on: true, mult: 1 },
    halo: { on: true, mult: 1 },
  },
  caption: { on: false, pos: 'bl', size: 4.5 },
  inspector: false,
}
